import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorApyCalculator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M9 6.75a.75.75 0 0 0-.75.75v.75H7.5a.75.75 0 0 0 0 1.5h.75v.75a.75.75 0 0 0 1.5 0v-.75h.75a.75.75 0 0 0 0-1.5h-.75V7.5A.75.75 0 0 0 9 6.75ZM13.5 9a.75.75 0 0 1 .75-.75h2.25a.75.75 0 0 1 0 1.5h-2.25A.75.75 0 0 1 13.5 9Zm-6.091 5.47a.75.75 0 1 1 1.06-1.061l.531.53.53-.53a.75.75 0 1 1 1.061 1.06l-.53.531.53.53a.75.75 0 0 1-1.06 1.06L9 16.06l-.531.531a.75.75 0 0 1-1.061-1.06l.53-.531-.53-.53Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M5.25 3A2.25 2.25 0 0 0 3 5.25v13.5A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V5.25A2.25 2.25 0 0 0 18.75 3H5.25ZM4.5 5.25a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V5.25Zm10.875 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-1.5.375a.375.375 0 0 0 0 .75h3a.375.375 0 0 0 0-.75h-3Zm2.25 1.875a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
    />
  </svg>
);
export default SvgTwoColorApyCalculator;
